
import { supabaseCustomRole } from "@/lib/supabase/customRoleClient";
import { Dealer } from "@/types/dealer";

export const fetchQuotationsForDealers = async (dealerIds: string[]) => {
  if (dealerIds.length === 0) return {};

  const { data: quotationsData, error: quotationsError } = await supabaseCustomRole
    .from('dealer_quotations')
    .select('dealer_id, spread_type, spread_percentage, spread_fixed')
    .eq('metal', 'ORO')
    .in('dealer_id', dealerIds);

  if (quotationsError || !quotationsData) {
    console.warn('Error fetching quotations:', quotationsError);
    return {};
  }

  const quotationsByDealer: Record<string, any> = {};
  quotationsData.forEach(quotation => {
    if (!quotationsByDealer[quotation.dealer_id]) {
      quotationsByDealer[quotation.dealer_id] = quotation;
    }
  });

  return quotationsByDealer;
};

export const formatDealerData = (
  dealersData: any[],
  quotationsByDealer: Record<string, any>
): Dealer[] => {
  console.log('formatDealerData - Raw dealer data sample:', dealersData.slice(0, 2).map(d => ({
    id: d.id,
    name: d.name,
    average_rating: d.average_rating,
    rating_count: d.rating_count,
    rating_count_type: typeof d.rating_count
  })));

  return dealersData.map((dealer: any) => {
    const quotation = quotationsByDealer[dealer.id];
    let buySpread = 5; // Default

    if (quotation) {
      buySpread = quotation.spread_type === 'FIXED'
        ? quotation.spread_fixed
        : quotation.spread_percentage;
    }

    // Process rating_count from database
    let rating_count = 0;
    if (dealer.rating_count !== null && dealer.rating_count !== undefined) {
      if (typeof dealer.rating_count === 'string') {
        rating_count = parseInt(dealer.rating_count);
        if (isNaN(rating_count)) rating_count = 0;
      } else if (typeof dealer.rating_count === 'number') {
        rating_count = dealer.rating_count;
      }
    }

    console.log(`Dealer ${dealer.name} - rating_count: ${dealer.rating_count} -> ${rating_count}`);

    return {
      id: dealer.id,
      name: dealer.name,
      address: dealer.address,
      city: dealer.city,
      rating: dealer.average_rating ? parseFloat(dealer.average_rating) : 0,
      rating_count: rating_count, // Add rating_count field
      is_verified: dealer.is_verified || false,
      activated: dealer.activated || false,
      isFavorite: false, // Will be updated by store
      latitude: dealer.latitude,
      longitude: dealer.longitude,
      buySpread,
      image_url: dealer.image_url,
      postal_code: dealer.postal_code,
      license: dealer.license,
      opening_hours: dealer.opening_hours,
      phone: dealer.phone,
      website: dealer.website,
      email: dealer.email
    };
  });
};

export const processDealer = async (
  dealersData: any[],
  count: number | null
) => {
  console.log(`Processing ${dealersData.length} dealers, total count: ${count}`);
  
  // Log raw data to verify rating_count is present
  if (dealersData.length > 0) {
    console.log('Raw dealer data from database:', dealersData[0]);
  }
  
  // Fetch quotations for all dealers in this page
  const dealerIds = dealersData.map((d: any) => d.id);
  const quotationsByDealer = await fetchQuotationsForDealers(dealerIds);
  
  // Format dealers
  const formattedDealers = formatDealerData(dealersData, quotationsByDealer);
  
  return {
    dealers: formattedDealers,
    totalCount: count || 0
  };
};
